import {CommonAlertService} from './../../services/common-alert.service';
import {filter} from 'rxjs/operators';
import {MasterService} from './../../home/services/master.service';
import {Component, OnInit, Inject} from '@angular/core';
import {MatDialogRef, MAT_DIALOG_DATA} from '@angular/material/dialog';
import {MatDatepickerModule} from '@angular/material/datepicker';
import {NgForm, Form} from '@angular/forms';


@Component({
  selector: 'app-stores-modal',
  templateUrl: './stores-modal.component.html',
  styleUrls: ['./stores-modal.component.scss']
})
export class StoresModalComponent implements OnInit {
  public locationsData: any;
  public warehousesData: any;
  public antennasData: any;
  public warehousesSelect: any;
  public editOb: any;
  public editData: any;
  // tslint:disable-next-line:variable-name
  public location_id: any;
  // tslint:disable-next-line:variable-name
  public warehouse_id: any;
  // tslint:disable-next-line:variable-name
  public antenna_id: any;
  public name: any;
  successMsg: any;
  public model = {
    location_id: '',
    warehouse_id: '',
    antenna_id: ''
  };
  public user = {
    name: '',
  };
  public editPermission = false;
  constructor(public dialogRef: MatDialogRef<StoresModalComponent>,
              public masterService: MasterService, @Inject(MAT_DIALOG_DATA) data, public commonAlertService: CommonAlertService) {
    if (data) {
      this.editOb = data.edit;
    }
  }

  ngOnInit() {
    // @ts-ignore
    // tslint:disable-next-line:triple-equals
    if (localStorage.getItem('roleId') == 0) {
      // @ts-ignore
      // tslint:disable-next-line:max-line-length
      this.editPermission = true;
    } else {
      const roles = JSON.parse(localStorage.getItem('roles'));
      // tslint:disable-next-line:triple-equals
      if (roles['more.stores.edit'] == 1) {
        this.editPermission = true;
      }
    }
    if (this.editOb) {
      const id = this.editOb.editID;
      // tslint:disable-next-line:variable-name
      const enc_id = this.editOb.encryId;

      this.masterService.getRecordById(id, enc_id, '/stores/get_data').subscribe(res => {
        // @ts-ignore
        this.editData = res.data.stores;
        this.model.location_id = this.editData.location_id;
        // @ts-ignore
        this.locationsData = res.data.locations;
        this.model.warehouse_id = this.editData.warehouse_id;
        // @ts-ignore
        this.warehousesData = res.data.warehouses;
        this.warehousesSelect = this.warehousesData;
        this.model.antenna_id = this.editData.antenna_id;
        // @ts-ignore
        this.antennasData = res.data.antennas;
        this.name = this.editData.antenna_name;
      });
    } else {
      this.masterService.getData('/locations/get').subscribe(res => {
        // @ts-ignore
        this.locationsData = res.data;
      });
      this.masterService.getData('/antennas/get').subscribe(res => {
        // @ts-ignore
        this.antennasData = res.data;
      });
    }
  }

  locationChange(args) {
    this.model.location_id = args.target.value;
    // tslint:disable-next-line:triple-equals
    this.warehousesSelect = this.warehousesData.filter(result => result.location_id == this.model.location_id);
  }

  submitForm(data) {

    if (this.editData) {
      // tslint:disable-next-line:max-line-length variable-name
      const form_data = Object.assign(data, { id: this.editOb.editID }, { enc_id: this.editOb.encryId }, { token: localStorage.getItem('token')});
      this.successMsg = 'Record Updated Successfully';
      this.masterService.addEditRecord(form_data, '/stores/update').subscribe(res => {
        // @ts-ignore
        if (res.success) {
          this.commonAlertService.showEdit({message: this.successMsg});
        }
      });

    } else {
      // tslint:disable-next-line:variable-name
      const form_data = Object.assign(data, { token: localStorage.getItem('token')});
      this.successMsg = 'Record Added Successfully';
      this.masterService.addEditRecord(form_data, '/stores/store').subscribe(res => {
        // @ts-ignore
        if (res.success) {
          this.commonAlertService.showSuccessMsg({message: this.successMsg});
        }
      });
    }
    this.close();
  }
  close() {
    this.dialogRef.close();
  }
}
